export const MAINTENANCE_MESSAGE =
  "Service is temporarily under maintenance. Please try again shortly.";

export const GENERIC_ERROR_MESSAGE = "Something went wrong. Please try again.";

const MAINTENANCE_PATTERNS = [
  /failed to fetch/i,
  /network\s*error/i,
  /network request failed/i,
  /timeout/i,
  /timed out/i,
  /service unavailable/i,
  /bad gateway/i,
  /gateway timeout/i,
  /\b5\d{2}\b/,
  /econnrefused/i,
  /cors/i,
  /maintenance/i,
];

const TECHNICAL_PATTERNS = [
  /typeerror/i,
  /referenceerror/i,
  /syntaxerror/i,
  /stack/i,
  /exception/i,
  /trace/i,
  /\bundefined\b/i,
  /\bnull\b/i,
  /\bjwt\b/i,
  /\btoken\b/i,
  /mongodb/i,
  /\bsql\b/i,
  /\bhttp\b/i,
  /<\/?[a-z][\s\S]*>/i,
];

const normalizeText = (input) =>
  String(input || "")
    .replace(/\s+/g, " ")
    .trim();

const extractErrorText = (error) => {
  if (!error) return "";
  if (typeof error === "string") return normalizeText(error);
  if (typeof error === "object") {
    return normalizeText(error?.message || error?.error || error?.msg || "");
  }
  return "";
};

const sanitizePrefix = (text) => text.replace(/^error\s*:\s*/i, "").trim();

export const toFriendlyErrorMessage = (error, fallback = GENERIC_ERROR_MESSAGE) => {
  const safeFallback = normalizeText(fallback) || GENERIC_ERROR_MESSAGE;
  const rawText = extractErrorText(error);
  if (!rawText) return safeFallback;

  const text = sanitizePrefix(rawText);
  if (!text) return safeFallback;

  if (text.length > 180) return safeFallback;
  if (MAINTENANCE_PATTERNS.some((pattern) => pattern.test(text))) return MAINTENANCE_MESSAGE;
  if (TECHNICAL_PATTERNS.some((pattern) => pattern.test(text))) return safeFallback;
  if (/[\r\n\t]/.test(String(error?.message || ""))) return safeFallback;

  return text;
};
